export const modalFooterCss = {
  width: "100%",
  display: "flex" as const,
  flexDirection: "row" as const,
  justifyContent: "space-between" as const,
  alignItems: "end" as const,
  padding: "0 16px 16px 16px",
};
